import React, { useState, useEffect, Component, Profiler, Suspense } from "react";
import "./App.css";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
// import i18n from './i18next';
import Home from "./Components/Pages/Home";
import Register from "./Components/Pages/Register";
// import Login from "./Components/Pages/Login";
import FindShipments from "./Components/Pages/FindShipments";
import About from "./Components/Pages/About";
// import Categories from "./Components/Archive/Categories";
import FindShippers from "./Components/Pages/FindShippers";
// import Footer from "./Components/Footer";
import ForBusiness from "./Components/Pages/ForBusiness";
import GettingStarted from "./Components/Pages/GettingStarted";
import Header from "./Components/Archive/Header";
// import Help from "./Components/Pages/Help";
import Imprint from "./Components/Pages/Imprint";
// import NavigationBar from "./Components/Archive/NavigationBar";
import NotFoundPage from "./Components/Pages/NotFoundPage";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy";
import ShipNow from "./Components/Pages/ShipNow";
import TermsAndConditions from "./Components/Pages/TermsAndConditions";
import Contact from "./Components/Pages/Contact";
// import { Layout } from "./Components/Archive/Layout";
import "bootstrap/dist/css/bootstrap.min.css";
// import Navbar from "./Components/Hompage-v-2/Navbar/Navbar";
// import Footer from "./Components/Hompage-v-2/Footer/Footer";
import BodyOfHomepage from "./Components/Hompage-v-2/Homepage/BodyOfHomepage";
import Profile from './Components/Hompage-v-2/Profile/Profile';
import Login from './Components/Hompage-v-2/LogIn-SignUp/Login';
import SignUp from './Components/Hompage-v-2/LogIn-SignUp/SignUp';
import Auction from './Components/Hompage-v-2/Auction/FormControl/AddressForm'
import CreateAuction from "./Components/Hompage-v-2/Auction/FormControl/CreateAuction";
import axios from "axios";
import Dashboard from "./Components/Hompage-v-2/Dashboard-log/DashboardNav/Dashboard";
import AuctionsTable from "./Components/Hompage-v-2/Dashboard-log/Table/AuctionsTable";



// function HeaderComponent() {

  



   


  // const [ t, i18n ] = useTranslation('common');
  // return (
  // 	<div>
  // 		<button onClick={() => i18n.changeLanguage('de')}>Deutsch</button>
  // 		<button onClick={() => i18n.changeLanguage('en')}>English</button>
  // 		<h1>{t('Thanks.1')}</h1>
  // 		<h3>{t('using.1')}</h3>
  //   <h3>{t('website.2')}</h3>
  // 	</div>
  // );
  /* <div className="App">
      <nav style={{ width:'100%', padding:'2rem 0', backgroundColor:'blue' }}>
        <button onClick={()=>handleclick('en')}>
//           English
//         </button>
//         <button onClick={()=>handleclick('de')}>
//           Deutsch
//         </button>
//       </nav>

//       <div className="Appheader"> */
  //         <div>Transporex</div>
  //         <p>{t('Thanks.1')}</p>
  //         <p>{t('using.1')}</p>
  //     </div>


const App = () => {
  
const [auctions, setAuctions] = useState([])
 useEffect(() => {
  fetch("/api/auctions")
  .then((res) => res.json())
  .then((data) => setAuctions(data))
  .catch((error) => console.log('Auctions not fetched'))
  //console.log(auctions)
 }, []);

console.log(auctions)
  return (
    <>
      {/* <Dashboard/> */}
      <Switch>
        <Route exact path='/' component={BodyOfHomepage} />
        <Route path='/login' component={Login}/>
        <Route path='/signup' component={SignUp}/>
        <Route path='/shippers' component={Profile}/>
        <Route path='/create-auction' component={CreateAuction}/>
        <Route path='/dashboard' component={Dashboard}
            // render={(props)=> ( <AuctionsTable auctions={auctions} setAuctions={setAuctions} {...props} /> )}
        />
        <Route path='/auctions-table' component={AuctionsTable}/>
        <Route path='/auction' component={Auction}/>
      </Switch>
    </>
  );
};

export default App;

{
  /* <Layout>
				<Router>
					<Switch>
						<Route exact path="/" component={Home} />
						<Route path="/" component={Register} />
						<Route path="/" component={Login} />
						<Route path="/" component={FindShipments} />
						<Route path="/" component={FindShippers} />
						<Route path="/" component={ShipNow} />
						<Route path="/" component={Contact} />
						<Route path="/" component={ForBusiness} />
						<Route path="/" component={GettingStarted} />
						<Route path="/" component={Categories} />
						<Route path="/" component={PrivacyPolicy} />
						<Route path="/" component={Help} />
						<Route path="/" component={TermsAndConditions} />
						<Route path="/" component={Imprint} />
						<Route path="/" component={About} />
						<Route path="/users/:id?" render={(props) => <Users users={users} {...props} />} />
						<Route path="/auctions/:id?" render={(props) => (<Auctions users={users} auctions={auctions} {...props} /> )}/>
						<Route path="/transporters/:id?" render={(props) => <Transporters transporters={transporters} {...props} />} />
						<Route component={NotFoundPage} />
						<Suspense fallback={<div>Loading </div>}>
							<Header />
						</Suspense>
					</Switch>
				</Router>
				
        		<Footer />
			</Layout> */
}
